import LeagueSeasonIndex from './LeagueSeasonIndex';
import LeagueSeasonCreate from './LeagueSeasonCreate';
import LeagueSeasonSettings from './LeagueSeasonSettings';
import LeagueSeasonSingle from './LeagueSeasonSingle';

export default function (app) {

    const settings = LeagueSeasonSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 9,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeagueSeasonIndex(app, settings);

    LeagueSeasonCreate(app, settings);

    LeagueSeasonSingle(app, settings);

}